const mediaMatch = {
  matcher: /channel9\.msdn\.com\/(.*)\/(.*)(?:#time=(.*))?/,
  url: 'https://channel9.msdn.com/$1/$2/player#time=$3:paused',
};

export default {
  mediaMatch,
};
